import React from 'react'
import styled from 'styled-components'
import RemoveFilterButton from './RemoveFilterButton'
import { useExploreColMappingData } from 'cmsHooks'
import CMS from '@talus-analytics/library.airtable-cms'
import device from 'utilities/device'

import { FilterProps } from './FilterBar'
import { removeFilter, removeAllFilters } from './filterOperations'
import useFilterOptions from 'dataHooks/useFilterOptions'
import getFilters from './getFilters'

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 2rem;
  margin: 1.5rem 0;
  @media ${device.tablet} {
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-start;
  }
`
const Flex = styled.div`
  display: flex;
  flex-direction: row;
`
const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`
const ClearFiltersButton = styled.button`
  font-size: 0.8rem;
  border: 1px solid ${({ theme }) => theme.text};
  background: none;
  background-color: ${({ theme }) => theme.background};
  padding: 0.2em 0.4em;
  border-radius: 5px;
  color: ${({ theme }) => theme.text};
  text-align: left;
  padding: 0.5em;
  box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.15);
  &:hover {
    box-shadow: 2px 2px 12px 0px rgba(0, 0, 0, 0.25);
  }
  height: min-content;
  @media ${device.tablet} {
    margin-right: 1rem;
  }
`
const MoreFiltersButton = styled(ClearFiltersButton)`
  margin-left: 1rem;
  margin-right: 0rem;
  @media ${device.tablet} {
    margin-left: 0rem;
  }
`

const ActiveFilters: React.FC<FilterProps> = ({
  exploreState,
  setExploreState,
}) => {
  const colMappingData = useExploreColMappingData()

  const filterOptions = useFilterOptions()
  const { moreFilters } = getFilters(filterOptions)

  return (
    <Grid>
      <FilterContainer>
        {exploreState.filters &&
          Object.entries(exploreState.filters).map(
            ([filterName, filterValues]) =>
              filterValues.map(value => (
                <RemoveFilterButton
                  key={value}
                  onClick={() =>
                    removeFilter({ [filterName]: [value] }, setExploreState)
                  }
                >
                  {CMS.getText(colMappingData, filterName.replace(/_/g, ' '))}:{' '}
                  <strong>{value}</strong>
                </RemoveFilterButton>
              ))
          )}
      </FilterContainer>
      <Flex>
        {exploreState.filters &&
          Object.keys(exploreState.filters).length > 0 && (
            <ClearFiltersButton
              onClick={() => removeAllFilters(setExploreState)}
            >
              Clear filters
            </ClearFiltersButton>
          )}
        {moreFilters.length > 0 && (
          <MoreFiltersButton
            onClick={() =>
              setExploreState(prev => ({
                ...prev,
                moreFilters: !prev.moreFilters,
              }))
            }
          >
            {exploreState.moreFilters ? 'Fewer' : 'More'} filters
          </MoreFiltersButton>
        )}
      </Flex>
    </Grid>
  )
}

export default ActiveFilters
